import React, { useState } from 'react';

import { apiRequest } from '../../utils/apiHelper';

import ActionDrawer from '../components/shared/ActionDrawer';
import { showSuccess, showError, showInfo, showServerError } from '../../utils/toastHelper';

function DiscountModal({ isOpen, onClose, selectedProducts, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    discountType: 'PERCENTAGE',
    discountValue: '',
    discountStartDate: '',
    discountEndDate: ''
  });

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!formData.discountValue) {
      showError('Lütfen indirim değerini girin');
      return;
    }

    if (formData.discountType === 'PERCENTAGE' && formData.discountValue > 100) {
      showError('Yüzde indirimi 100\'den büyük olamaz');
      return;
    }

    try {
      setLoading(true);

      const response = await apiRequest('/products/bulk-discount', {
        method: 'POST',
        body: JSON.stringify({
          productIds: selectedProducts.map(p => p.id),
          ...formData
        })
      });

      if (response.success) {
        showSuccess('İndirimler başarıyla uygulandı');
        onSuccess();
      } else {
        throw new Error(response.message || 'İndirim uygulanırken bir hata oluştu');
      }
    } catch (error) {
      console.error('Failed to apply discount:', error);
      if (error.apiError) {
        showServerError();
      } else {
        showError(error.message || 'İndirim uygulanırken bir hata oluştu');
      }
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <div className="d-flex justify-content-end gap-2 w-100">
      <button
        type="button"
        className="btn btn-light"
        onClick={onClose}
        disabled={loading}
      >
        İptal
      </button>
      <button
        type="button"
        className="btn btn-primary"
        disabled={loading || !formData.discountValue}
        onClick={handleSubmit}
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
            İndirim Uygulanıyor...
          </>
        ) : (
          <>
            <i className="fas fa-percentage me-2" />
            İndirimi Uygula
          </>
        )}
      </button>
    </div>
  );

  return (
    <ActionDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="İndirim Uygula"
      width="600px"
      footer={footer}
    >
      <div className="discount-form-content">
        <div className="alert alert-info py-2">
          <i className="fas fa-info-circle me-2"></i>
          {selectedProducts?.length} ürün seçildi
        </div>

        <div className="mb-3">
          <label className="form-label text-muted small fw-medium">İndirim Tipi</label>
          <select
            className="form-select"
            value={formData.discountType}
            onChange={(e) => setFormData({ ...formData, discountType: e.target.value })}
            disabled={loading}
          >
            <option value="PERCENTAGE">Yüzde İndirim (%)</option>
            <option value="FIXED_AMOUNT">Tutar İndirimi (TL)</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label text-muted small fw-medium">İndirim Değeri</label>
          <div className="input-group">
            <input
              type="number"
              className="form-control no-wheel"
              value={formData.discountValue}
              onChange={(e) => setFormData({ ...formData, discountValue: e.target.value })}
              onWheel={(e) => e.target.blur()}
              disabled={loading}
              min="0"
              max={formData.discountType === 'PERCENTAGE' ? "100" : undefined}
              step="0.01"
              required
            />
            <span className="input-group-text">
              {formData.discountType === 'PERCENTAGE' ? '%' : 'TL'}
            </span>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label text-muted small fw-medium">Başlangıç Tarihi</label>
          <input
            type="datetime-local"
            className="form-control"
            value={formData.discountStartDate}
            onChange={(e) => setFormData({ ...formData, discountStartDate: e.target.value })}
            disabled={loading}
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-muted small fw-medium">Bitiş Tarihi</label>
          <input
            type="datetime-local"
            className="form-control"
            value={formData.discountEndDate}
            onChange={(e) => setFormData({ ...formData, discountEndDate: e.target.value })}
            disabled={loading}
            min={formData.discountStartDate}
          />
        </div>
      </div>

      <style>{`
        /* Number inputlarda wheel olayını engelle */
        input.no-wheel::-webkit-outer-spin-button,
        input.no-wheel::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input.no-wheel {
          -moz-appearance: textfield;
        }
      `}</style>
    </ActionDrawer>
  );
}

export default DiscountModal; 